import { render, staticRenderFns } from "./postAd.vue?vue&type=template&id=598878d6&"
import script from "./postAd.vue?vue&type=script&lang=js&"
export * from "./postAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports